// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7fvjH","title":"styles_title__fmNjA"};